/* import __COLOCATED_TEMPLATE__ from './section.hbs'; */
import Component from '@glimmer/component';

export default class Section extends Component {}
